import type { SidebarItemProps } from "../types";
import {
  CubeIcon,
  DocumentChartBarIcon,
  QueueListIcon,
  UserGroupIcon,
  FolderIcon,
  ChartBarIcon,
} from "@heroicons/react/24/solid";

export const sidebarItems: SidebarItemProps[] = [
  {
    label: "Expedientes",
    icon: <DocumentChartBarIcon className="h-5 w-5" />,
    href: "/folders",
  },
  {
    label: "Mis Expedientes",
    icon: <FolderIcon className="h-5 w-5" />,
    href: "/my-folders",
  },
  {
    label: "Plantillas",
    icon: <CubeIcon className="h-5 w-5" />,
    href: "/templates",
  },
  {
    label: "Requisitos",
    icon: <QueueListIcon className="h-5 w-5" />,
    href: "/base-requirements",
  },
  {
    label: "Métricas",
    icon: <ChartBarIcon className="h-5 w-5" />,
    href: "/sla-metrics",
  },
  {
    label: "Usuarios",
    icon: <UserGroupIcon className="h-5 w-5" />,
    href: "/users",
  },
];
